module.exports = __webpack_public_path__ + "img/approve-list17.d84ef0fd.png";